import { render, staticRenderFns } from "./ContentBlocks.vue?vue&type=template&id=5225141f"
import script from "./ContentBlocks.vue?vue&type=script&lang=js"
export * from "./ContentBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports